// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-confirm-alert/src/react-confirm-alert.css
// module id = 1122
// module chunks = 2